<div class="tab-container {{tab_container_class}} {{#if stepper}}tab-stepper{{/if}} {{#if vertical}}tab-vertical{{/if}} ">
  <ul class="tabs has-{{tabs.length}}tabs" role="tablist">
    {{#each tabs}}
      <li role="presentation" class="tab {{tab_class}} {{#if (equal @index ../default)}}active{{/if}}" {{#if (equal @index ../default)}} tabindex="0"{{else}}tabindex="-1"{{/if}} data-index="{{@index}}">
        <a role="tab" tabindex="-1" class="tab-link {{tab_link_class}}" href="#{{id}}_pane" id="{{id}}" data-toggle="tab" data-aria-not-complete-label="{{pt text}} {{pt 'notCompleted'}}" data-aria-complete-label="{{#if text_completed}}{{pt text_completed}}{{else}}{{pt text}} {{pt 'completed'}}{{/if}}">
          {{#if ../defaultIcons}}
            {{#if ../defaultIcons.visited.icon_prefix}}
              <i title="{{t 'Unvisited Tab'}}" id="icon-{{id}}" class="icon-close-choice-{{id}} tab-icon">
                <div class="tab-icon-visited">{{>icon uuid=../cid index=@index prefix=../defaultIcons.visited.icon_prefix name=../defaultIcons.visited.icon_name sr_caption='icon for tab status'}}</div>
                <div class="tab-icon-unvisited">{{>icon uuid=../cid index=@index prefix=../defaultIcons.unvisited.icon_prefix name=../defaultIcons.unvisited.icon_name sr_caption='icon for tab status'}}</div>
                <div class="tab-icon-current">{{>icon uuid=../cid index=@index prefix=../defaultIcons.current.icon_prefix name=../defaultIcons.current.icon_name sr_caption='icon for tab status'}}</div>
              </i>
            {{else}}
              <i title="{{t 'Unvisited Tab'}}" id="icon-{{id}}" class="icon-close-choice-{{id}} tab-icon">
                <div class="tab-icon-visited">{{>icon uuid=../cid index=@index icon=../defaultIcons.visited sr_caption='icon for tab status'}}</div>
                <div class="tab-icon-unvisited">{{>icon uuid=../cid index=@index icon=../defaultIcons.unvisited sr_caption='icon for tab status'}}</div>
                <div class="tab-icon-current">{{>icon uuid=../cid index=@index icon=../defaultIcons.current sr_caption='icon for tab status'}}</div>
              </i>
            {{/if}}
          {{/if}}
          {{#if image}}
            <img class="img-tab" title="{{t image.title}}" src="{{assetPath image.path}}" width="{{#if image.width}}{{image.width}}{{/if}}" height="{{#if image.height}}{{image.height}}{{/if}}"/>
          {{else}}
            {{#if iconTab}}
              {{>icon uuid=../cid index=@index prefix=iconTab.icon_prefix name=iconTab.icon_name sr_caption=iconTab.icon_title}}
            {{else}}
              {{>icon uuid=../cid index=@index icon=icon sr_caption=icon.icon_title}}
            {{/if}}
          {{/if}}
          
          {{#if ../stepper}}
          <div class="tab-step">
            <span class="number">{{indexToCount @index}}</span>
            {{>icon uuid=../cid index=@index icon="fal fa-check" classes="icon" sr_caption="Check icon for stepper"}}
          </div>
          {{/if}}
          <div class="tab-label">{{t text}}</div>
        </a>
      </li>
    {{/each}}
  </ul>
  <div class="tab-content">
    {{#each tabs}}
      <div role="tabpanel" class="tab-pane {{tab_pane_class}} {{#if (equal @index ../default)}}active{{/if}}" id="{{id}}_pane" aria-labelledby="{{id}}" {{#if (equal @index ../default)}}tabindex="0"{{/if}}>
        {{#if blocks}}
          <div data-region="{{../cid}}-tabs-{{@index}}-blocks"></div>
        {{/if}}
      </div>
    {{/each}}
  </div>
</div>
